import { render, staticRenderFns } from "./TempPassConfirm.vue?vue&type=template&id=b40e4854&"
import script from "./TempPassConfirm.vue?vue&type=script&lang=js&"
export * from "./TempPassConfirm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports